import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.NEXT_PUBLIC_API_BASE_URL,
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    // @ts-ignore
    const { token } = getState()?.auth;
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const apiHooks = createApi({
  baseQuery,
  tagTypes: ["Dashboard", "Pools", "Tokens"],
  endpoints: (builder) => ({
    dummyEndpoint: builder.mutation({
      query: (email) => ({
        url: `waitlist`,
        method: "POST",
        body: {
          email,
        },
      }),
    }),
  }),
});

export const { useDummyEndpointMutation } = apiHooks;
